<!-- // footer section \\ -->
<section class="footer-section">
  <div class="comman-width">
    <div class="row">
      <!--little angle footer start-->

      <!-- <div class="littleAngelFooter" *ngIf="littleAngleFooter">
      <div class="littleAngelContact">
        <div class="phoneIcon">
          <img src="../../assets/images/phoneFooter.svg">
          <span><a href="tel:98100 98100">+91 98100 98100</a></span>
        </div>
        <div class="emailIcon">
          <img src="../../assets/images/emailFooter.svg">
          <span><a href="mailto:help@littleangelhands.com">help@littleangelhands.com</a></span>
        </div>
        </div>
        <div class="socialFooter">
          <span>Connect us on</span>
          <div>
            <a href="https://www.linkedin.com/company/rxhacker" target="_blank"><img src="../../assets/images/littlelinkedin.svg"></a>
            <a href="https://www.instagram.com/rxhackerpro/" target="_blank"><img src="../../assets/images/littleinstagram.svg"></a>
            <a href="https://www.facebook.com/Rxhackerpro"  target="_blank"><img src="../../assets/images/littlefacebook.svg"></a>
            <a href="mailto:support@nulifespanrx.com"  target="_blank"><img src="../../assets/images/littleemail.svg"></a>
            <a href="https://www.youtube.com/channel/UCkCz96xhL3i_FD55jgbxdBg" target="_blank"><img src="../../assets/images/littleyoutube.svg"></a>
          </div>
        </div>
        <div class="littleAngelCopyright">
          <p>Copyright Information: © 2023 Little Angel Hands. All rights reserved.</p>
        </div>
      </div> -->
      <!--little angle footer end-->
      <div class="footer-adjust">
        <div class="col-lg-4 col-md-4 col-sm-12">
          <h2 class="RxHackerDiscountFooter column-title">Get your discount card</h2>
          <div class="walletDiv">
            <div class="discountWallet" (click)="openpass(applegenericpassval)"  *ngIf="ios">
              <img src="../../assets/images/apple_wallet.png">
              <span><label>Add to</label> Apple wallet</span>
            </div>
            <div class="discountWallet google-wall" (click)="openpass(googlegenericpassval)" *ngIf="android">
              <img src="../../assets/images/google_wallet.png">
              <span><label>Add to</label> Google wallet</span>
            </div>    
          </div>  
        </div>
        <div class="col-lg-8 col-md-8 col-sm-12 footer-right">
          <div class="col-lg-3 col-md-3 col-sm-3 first left">
            <h2 class="RxHackerDiscountFooter column-title">{{ brandName }}</h2>
            <ul class="footer-nav">
              <li>
                <div class="cool-link" [routerLink]="['/']" fragment="howItWorks">
                  <a href="/#howItWorks">How it Works </a>
                </div>  
              </li>
              <li>
                
                <a class="cool-link" [routerLink]="['/pet-prescriptions']" (click)="slideToggle()">
                  Pet Prescriptions
                </a>
  
              </li>
              <li>                
                <a class="cool-link" [routerLink]="['/little-angel-hands']" (click)="slideToggle()">
                  Little Angel Hands
                </a>
              </li>
              <!--<li>                
                <a class="cool-link" [routerLink]="['/fit-economy']" (click)="slideToggle()">
                  Move To Earn
                </a>  
              </li>-->
              <li>                
                <a class="cool-link" [routerLink]="['/Underinsured']" (click)="slideToggle()">
                  Underinsured
                </a>  
              </li>
            </ul>
          </div>
          <div class="col-lg-3 col-md-2 col-sm-3 right">
            <h2 class="RxHackerDiscountFooter column-title">Savings</h2>
            <ul>
              <li>
                <a class="cool-link" [routerLink]="['/pricing']" (click)="slideToggle()" routerLinkActive="active">Pricing
                  Tool<span>&nbsp;</span></a>
              </li>
              <li>
                <a class="cool-link" [routerLink]="['/MyCards']" (click)="slideToggle()" routerLinkActive="active">My
                  Cards<span>&nbsp;</span></a>
              </li>
              <li>
                <a class="cool-link" [routerLink]="['/drugs']" (click)="slideToggle()"
                  routerLinkActive="active">Drugs Covered<span>&nbsp;</span></a>
              </li>
              <li>
                <a href="javascript:;" class="cool-link" id="footerlinksignup" (click)="signuppop()">Sign Up / Log In</a>
              </li>
              <li>
                <a class="cool-link" href="https://backoffice.nulifespanrx.com/login" target="_blank"
                  (click)="slideToggle()">Affiliate Login<span>&nbsp;</span></a>
              </li>
            </ul>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12 help left">
            <h2 class="RxHackerDiscountFooter column-title">Support</h2>
            <ul>
              <li>
                <a class="cool-link" [routerLink]="['/contact']" routerLinkActive="active">Contact Us<span>&nbsp;</span></a>
              </li>
              <li>
                <a class="cool-link" [routerLink]="['/contact']" routerLinkActive="active">Help<span>&nbsp;</span></a>
              </li>
              <li>
                <a class="cool-link" [routerLink]="['/terms']" routerLinkActive="active">Terms of Use<span>&nbsp;</span></a>
              </li>
              <li>
                <a class="cool-link" [routerLink]="['/privacy']" routerLinkActive="active">Privacy Policy<span>&nbsp;</span></a>
              </li>
              <li>
                <a class="cool-link" [routerLink]="['/program']" routerLinkActive="active">Program Description<span>&nbsp;</span></a>
              </li>
            </ul>
          </div>
          <!-- <div class="col-lg-3 col-md-3 col-sm-6 fourth"> 
            <div style="text-align: left;">
              
              <div class="app-link d-app-link" style="justify-content: left;">
                
                
              </div>
             
  
            
            </div>
          </div> -->
  
          <!-- <div class="col-lg-4 col-md-4 col-sm-12 fourth">
            <h2 class="column-title">Download RxHacker App Now!</h2>
            <ul class="social">
              <li class="store">
                <a href="https://apps.apple.com/us/app/rxhacker/id1450904899" target="_blank"><img class="gap"
                    src="assets/images/app_store.svg" alt="RxHacker mobile app is available on the Apple App Store" width="136" height="42" /></a>
                <a href="https://play.google.com/store/apps/details?id=com.firebase.rxhacker&hl=en_IN"
                  target="_blank"><img class="gap" src="assets/images/play_store.svg" alt="RxHacker mobile app is available on the Google Play Store" width="136" height="42" /></a>
              </li>
              <li>
                <p class="get">Let us text you a link to download our free Android or iPhone app!</p>
              </li>
              <li>
                <form class="footer-download">
                  <input class="form-control differ shadow" [(ngModel)]="sendno" (keypress)="removemsgerr($event)"
                    (focus)="removemsgerr($event)" pattern="[789][0-9]{9}" type="text" name="mno"
                    placeholder="Enter Mobile No." maxlength="14" autocomplete="off" />
  
                  <button class=" btn secondary d-app-btn" (click)="sendmsg(sendno)">
                    Get Link
                  </button>
                </form>
                <p class="colorRed dummy-margin" *ngIf="sendmessageStatus">{{ sendmessageStatus }}</p>
              </li>
  
            </ul>
          </div> -->
  
          <div class="col-lg-3 col-md-3 col-sm-3 fourth right">
            <h2 class="column-title">Follow {{ brandName }}</h2>
            <ul class="social mobile">
              <!--<li>
                <img src="../../../assets/images/linkedin.svg" alt="RxHacker is on LinkedIn! Find others saving on their prescription discounts" width="26" height="26" />
                <a class="cool-link" href="https://www.linkedin.com/company/rxhackerpro/"
                  target="_blank">Linked In</a>
              </li>
            -->
              <li>
                <img src="../../../assets/images/instagram.svg" alt="NuLifeSpan Rx is on Instagram! Find others saving on their prescription discounts" width="26" height="26" />
                <a class="cool-link" href="https://www.instagram.com/rxhackerdiscountcard/" target="_blank">Instagram</a>
              </li>
              <li>
                <img src="../../../assets/images/facebook.svg" class="NuLifeSpan Rx is on Facebook! Find others saving on their prescription discounts" width="26" height="26" />
                <a class="cool-link" href="https://www.facebook.com/Rx-Hacker-Pro-103647705256844" target="_blank">Facebook</a>
              </li>
              <div class="block">
                <!--
                <li>
                  <img src="../../../assets/images/youtube.svg" alt="RxHacker is on Youtube! Learn more on how you can save on your prescriptions" width="26" height="26" />
                  <a class="cool-link" href="https://www.youtube.com/channel/UCkCz96xhL3i_FD55jgbxdBg"
                    target="_blank">YouTube</a>
                </li>
                <li>
                  <img src="../../../assets/images/twitter.svg" alt="RxHacker is on Twitter! Find others saving on their prescription discounts" width="26" height="26" />
                  <a class="cool-link" href="https://twitter.com/RxHackerPro" target="_blank">Twitter</a>
                </li>
                -->
                <li>
                  <img src="../../../assets/images/email.svg" alt="Email NuLifeSpan Rx with questions on your discount card" width="26" height="26" />
                  <a class="cool-link" href="mailto:support@nulifespanrx.com">Email</a>
                </li>
              </div>
            </ul>
          </div>  
        </div>
      </div>
    </div>
  </div>

  <div class="copyright">
    <div class="comman-width">
      <!-- <ul>
        <li>
          <a class="cool-link" href="#">Terms</a>
        </li>
        <li>
          <a class="cool-link" href="#">Privacy</a>
        </li> -->
        <!-- <li>
          <a class="cool-link" [routerLink]="['/domain-affiliate']">Domain Affiliate</a>
        </li> -->
          <!--<li>
              <a class="cool-link" [routerLink]="['/terms']" (click)="slideToggle()" routerLinkActive="active">Terms</a>
               | <a class="cool-link" [routerLink]="['/privacy']" (click)="slideToggle()" routerLinkActive="active">Privacy</a> | &copy; {{currentYear}} RxHacker. All rights reserved. 
          </li>
      </ul>-->
      <!--p><a class="cool-link" [routerLink]="['/terms']" routerLinkActive="active">Terms of Use<span>&nbsp;</span></a> | <a class="cool-link" [routerLink]="['/privacy']" routerLinkActive="active">Privacy Policy<span>&nbsp;</span></a> | &copy; {{currentYear}} NuLifeSpan Rx LLC. All Rights Reserved.</p-->
      <p>Pharmacy names, logos, brands, and other trademarks are the property of their respective owners.</p>
      <p>The NuLifeSpan Rx prescription discount program is free. This is not insurance. It is also not a Medicare prescription drug plan. The range of prescription discounts provided under this discount program will vary depending on the prescription and pharmacy where the prescription is purchased and can be up to $95 off the retail price. Purchases using the NuLifeSpan Rx program do not count towards insurance or Medicare deductibles or out-of-pocket maximums. You are fully responsible for paying your prescriptions at the pharmacy at the time of service, but you will be entitled to receive a discount from the pharmacy in accordance with the specific pre-negotiated discounted rate schedule. NuLifeSpan Rx LLC is the Administrator of the NuLifeSpan Rx prescription discount program with its office located at One Marina Park Drive, Suite 1410, Boston MA 02210. Toll Free at (844) 944-4542 and email at support@nulifespanrx.com. For additional information, including an up-to-date list of pharmacies and covered prescriptions, or assistance with any problems related to this prescription drug discount plan, please contact our member support line toll free at (800) 984-4031 or visit nulifespanrx.com. By using the NuLifeSpan Rx prescription discount program or app, you agree to the NuLifeSpan Rx Terms and Conditions found at http://nulifespanrx.com/terms.</p>
      <p>&copy; {{currentYear}} NuLifeSpan Rx LLC. All Rights Reserved.</p>
    </div>
  </div>
  <!-- <script src="https://static.legitscript.com/seals/4837303.js"></script> -->
</section>
<!-- \\ footer section // -->
<div class="showemailpopup" *ngIf="showemailpopup">
  <div class="inner">
    <h3>Share Pass</h3>
    <p>Looks like you're on Chrome for iOS. Please enter your email below to receive your Apple pass
    </p>
    <div class="email_field" style="position: relative">
      <input type="email" id="UserInputEmailcard" name="UserInputEmailcard" placeholder="Enter your E-mail" [(ngModel)]="UserInputEmailcard"
        (click)="ClearMessage($event)" (blur)="ClearMessage($event)" (keypress)="ClearMessage()"
        autocomplete="off" />
      <!-- <label for="email">Enter your E-mail</label> -->
      <div class="sendbtn" (click)="SharePassonemail()">{{Sendtext}}</div>
      <div class="loadProcess"></div>
    </div>
    <p class="error" *ngIf="UserInputEmailcarderror !=''">{{UserInputEmailcarderror}}</p>
  </div>
</div>
<!-- Tabs panel -->
<div class="signupbox " *ngIf="showloginbox">
  <div class="close_search_pharmacy_popup" (click)="removesignup($event)"></div>
  <div class="signup_hero"></div>
  <div class="Signup_login">
    <div class="background_area">
      <div class="gradient_bg is-hidden-mobile"></div>
      <img class="auth_logo" src="/assets/images/logo.png" />
      <p>
        Sign up to save upto 80% on Prescriptions!
      </p>
    </div>
    <div class="form_area">
      <nav>
        <a href="javascript:;" (click)="openlogin_signup($event, 'sign_in')" [class.active]="signin_fields">Sign In</a>
        <a href="javascript:;" (click)="openlogin_signup($event, 'sign_up')" [class.active]="signup_fields">Sign Up</a>
      </nav>
      <div class="signup_parent" *ngIf="signup_fields">
        <div class="form_sec">
          <!-- <div class="skip_btn" (click)="SkipSignUp()">Skip Sign up</div> -->
          <h2>Sign Up to {{ _AppName }}</h2>
          <div class="field">
            <input type="email" name="email_signup" id="email_signup" placeholder=" " [(ngModel)]="sign_up_email"
              autocomplete="off" (keyup)="Keyup_ClearField($event)" (blur)="OnBlur_CheckPattern($event)" />
            <label for="email_signup">Email Address</label>
          </div>
          <span>{{ sign_up_email_error }}</span>
          <div class="field">
            <input type="password" name="password_signup" id="password_signup" [(ngModel)]="sign_up_password"
              minlength="6" maxlength="20" autocomplete="off" placeholder=" " (keyup)="Keyup_ClearField($event)"
              (blur)="OnBlur_CheckPattern($event)" (keypress)="StopWhiteSpace($event)" />
            <label for="password_signup">Password</label>
          </div>
          <span>{{ sign_up_password_error }}</span>
          <div class="field">
            <input type="password" name="c_password_signup" id="c_password_signup" [(ngModel)]="sign_up_cpassword"
              minlength="6" maxlength="20" autocomplete="off" placeholder=" " (keyup)="Keyup_ClearField($event)"
              (blur)="OnBlur_CheckPattern($event)" (keypress)="StopWhiteSpace($event)" />
            <label for="c_password_signup">Confirm Password</label>
          </div>
          <span>{{ sign_up_cpassword_error }}</span>
        </div>
        <div class="signup_btn_sec">
          <div class="btns" (click)="MakeSignUp()">
            Sign Up
          </div>
          <div class="already">
            Already have an account?
            <a href="javascript:;" (click)="openlogin_signup($event, 'sign_in')">Sign In here</a>
          </div>
        </div>
        <div class="Login_Signup_Error">{{ sign_up_error }}</div>
        <p class="tncbox">
          By tapping Sign Up below, you confirm that you accept the
          <a [routerLink]="['/termsofuse']" target="_blank">Terms of Use</a>.
        </p>
      </div>

      <div class="signin_parent" *ngIf="signin_fields">
        <div class="form_sec">
          <h2>Sign In to {{ _AppName }}</h2>
          <div class="field">
            <input type="email" name="email_signin" id="email_signin" placeholder=" " [(ngModel)]="sign_in_email"
              autocomplete="off" (keyup)="Keyup_ClearField($event)" (blur)="OnBlur_CheckPattern($event)" />
            <label for="email_signin">Email Address</label>
          </div>
          <span>{{ sign_in_email_error }}</span>
          <div class="field">
            <input type="password" name="password_signin" id="password_signin" placeholder=" "
              [(ngModel)]="sign_in_password" (keyup)="Keyup_ClearField($event)" (blur)="OnBlur_CheckPattern($event)"
              autocomplete="off" (keypress)="StopWhiteSpace($event)" />
            <label for="password_signin">Password</label>
          </div>
          <span>{{ sign_in_password_error }}</span>
        </div>
        <a href="javascript:;" class="forgot_btn" (click)="ForgotPassword()">Forgot Password</a>
        <div class="signup_btn_sec">
          <div class="btns" (click)="MakeSignIn()">
            Sign In
          </div>
          <div class="already">
            Don’t have account ?
            <a href="javascript:;" (click)="openlogin_signup($event, 'sign_up')">Sign up here</a>
          </div>
        </div>
        <div class="Login_Signup_Error">{{ sign_in_error }}</div>
      </div>
    </div>
  </div>
</div>